<div  class="size-map" style="position: relative;box-shadow: 2px 2px 12px 0 rgba(69, 90, 100, 0.25);" >
  <div id="map" class="size-map"></div>

  <div class="grid-info">    
      <div class="row d-flex align-items-center">       
          <img src="assets/imgs/icon_coord_antiga.svg" class="mr-2">     
          <div>
            <p class="mb-0 sub-titulo">Coordenada anterior</p>    
            <p class="mb-0 titulo">{{ this.latAntiga.toFixed(3)}}, {{ this.longAntiga.toFixed(3)}} </p>   
          </div>
      </div>

      <div class="info-dif" >
        <div class="col">
          <span class="d-block sub-titulo pt-1">Diferença</span>
          <span class="titulo">     {{ distanciaDiff >= 1000 ? (distanciaDiff / 1000).toFixed(2) + 'km' : distanciaDiff.toFixed(2) + 'm' }}</span>
        </div>
      </div>

      <div class="row d-flex align-items-center"> 
          <img src="assets/imgs/icon_coord_atual.svg" class="mr-2">  
          <div>
            <p class="mb-0 sub-titulo">Nova coordenada</p>    
            <p class="mb-0 titulo">{{ this.latNova.toFixed(3)}}, {{ this.longNova.toFixed(3)}}</p>   
          </div>  
      </div>
  </div>
  
  <button class="btn btn-street shadow" (click)="abreStreetViewPrincipal()"> <i class="fa fa-map-o mr-2"></i>Abrir street view</button>
</div>

